import React from 'react';
import { Link } from 'react-router-dom';
import { Users, ArrowRight } from 'lucide-react';

export default function EmployeeManagementRedirect() {
  return (
    <div className="mb-6 rounded-xl border border-acctoo-200 bg-gradient-to-br from-acctoo-50 to-white p-8 text-center shadow-sm">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-acctoo-100">
        <Users className="h-7 w-7 text-acctoo-700" aria-hidden />
      </div>
      <h3 className="text-lg font-semibold text-acctoo-900">Employee profiles &amp; salary setup</h3>
      <p className="mx-auto mt-2 max-w-md text-sm text-acctoo-700">
        Add and edit employees, set annual basic salary and bonus, and manage KYC documents in Employee
        Management. Process monthly payroll from the Salaries tab.
      </p>
      <Link
        to="/employee-management"
        className="mt-6 inline-flex items-center gap-2 rounded-lg bg-acctoo-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-acctoo-700"
      >
        Open Employee Management
        <ArrowRight className="h-4 w-4" aria-hidden />
      </Link>
    </div>
  );
}
